import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthComponent } from './pages/auth/auth.component';
import { AuthModule } from './pages/auth/auth.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { HttpDataService } from '../../src/app/_service/http-data.service';
import { AuthenticationService } from '../../src/app/_service/authentication.service';
import { SharedModule } from '../../src/app/shared/shared.module';
import { NavComponent } from './pages/nav/nav.component';
import { AppConfigService } from '../../src/app/_service/app-config.service';
import { ServiceConfigService } from '../../src/app/_service/service-config.service';
import { ServiceAdapterService } from '../../src/app/_service/service-adapter.service';
import { CacheService } from '../../src/app/_service/cache.service';
import { HttpInterceptorService } from '../../src/app/_helpers/http-interceptor.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MaterialModule } from '../../src/app/material/material.module';
import { TreeModule } from '@circlon/angular-tree-component';
import { ChartModule } from 'angular-highcharts';
import { HighchartsService } from '../../src/app/_service/highcharts.service';
import { MapModule } from "angular-maps";
import { MapAPILoader } from 'angular-maps';
import { BingMapAPILoaderConfig } from 'angular-maps';
import { BingMapAPILoader } from 'angular-maps';
import { WindowRef } from 'angular-maps';
import { DocumentRef } from 'angular-maps';
import { BingMapsAPILoaderService } from './_helpers/bing-maps-apiloader.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from './pages/home/home.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { AzureMapTokenConfigService } from '../../src/app/_service/azure-map-token-config.service';
import { ConsoleToggleService } from '../../src/app/_service/console-toggle.service';


export function initialConfigLoad(config: AppConfigService) {
       return () => config.load();
};
export function initialConfigLoadSavings(config: ServiceConfigService) {
      return () => config.load();
};
export function initialConfigAzureMap(config: AzureMapTokenConfigService) {
  return () => config.load();
};
// localization module import
import { TranslateModule, TranslateLoader, TranslateService } from  '@ngx-translate/core';
import { TranslateHttpLoader } from  '@ngx-translate/http-loader';
import { ComparisonComponent } from './modules/comparison/comparison/comparison.component';
import { ErrorpageComponent } from './pages/errorpage/errorpage.component';;

// loader module
export  function  HttpLoaderFactory(http:  HttpClient) {
  return  new  TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    AuthComponent,
    NavComponent,
    HomeComponent,
    ComparisonComponent,
    ErrorpageComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    AuthModule,
    SharedModule,
    BrowserAnimationsModule,
    MaterialModule,
    TreeModule,
    ChartModule,
    MatTooltipModule,
    MapModule.forRoot(),
    NgbModule,
    TranslateModule.forRoot({
      loader: {
        provide:  TranslateLoader,
        useFactory:  HttpLoaderFactory,
        deps: [HttpClient]
      }
    })
  ],
  exports: [TranslateModule],
  providers: [
    ConsoleToggleService,
    TranslateService,
    AppConfigService,
    {
        provide: APP_INITIALIZER,
        useFactory: initialConfigLoad,
        deps: [AppConfigService],
        multi: true,
    },
    ServiceConfigService,
        {
        provide: APP_INITIALIZER,
        useFactory: initialConfigLoadSavings,
        deps: [ServiceConfigService],
        multi: true
        
    },
    // AzureMapTokenConfigService,
    // {
    // provide: APP_INITIALIZER,
    // useFactory: initialConfigAzureMap,
    // deps: [AzureMapTokenConfigService],
    // multi: true
    // },
    HttpDataService,AuthenticationService,ServiceAdapterService,CacheService,HighchartsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true
    },{
      provide: MapAPILoader, deps: [], useFactory: MapServiceProviderFactory
  },
  BingMapsAPILoaderService
],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function MapServiceProviderFactory(){
  let bc: BingMapAPILoaderConfig = new BingMapAPILoaderConfig();
  bc.apiKey ="AulJ_huKLvOZqTz8-C2b5v1vMTT0qTqUzX4HPLOtJoeY9RJ1__QdZtn1I2wzFKLN"; // your bing map key
  bc.branch = "experimental"; 
  return new BingMapAPILoader(bc, new WindowRef(), new DocumentRef());
}
